export default __webpack_public_path__ + "static/char-v-55-6a9a166bc0248e0a00544e975f7c78b6.webp";